import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { AddButton, CancelSubmitButton, Space } from '../../../Res/BaseButton';
import { AutoSelect } from '../../../Res/AutoSelect';
import { ContentBox } from '../../ContentBox';
import { PLAYER_CURRENTLY_NOW, ReqPlayerHistoryList, RespPlayerHistory } from '../../../../../item/MyStat/ItemPlayerHistory';
import { api_addPlayerHistory, api_getPlayerHistoryList, api_getPlayerLeagueList, api_updatePlayerHistorys } from '../../../../../api/MyStat/apiPlayerHistory';
import Swal from 'sweetalert2';
import { PlayerHistory } from './PlayerHistory';
import { getKey } from '../../../../../item/ItemTools';


export function PlayerHistoryList({ pId, setIsLoading }) {
  const [player_id, set_player_id] = useState("")
  const [league_list, set_league_list] = useState([])
  const [league_id, set_league_id] = useState('')

  const [player_history_list, set_player_history_list] = useState([])

  const [history_err, set_history_err] = useState(false)

  useEffect(() => {
    if (pId !== [] && pId !== player_id) {
      set_player_id(pId)
    }
  }, [pId])

  useEffect(() => {
    if (player_id !== "") {
      getPlayerLeagueList()
      getPlayerHistoryList()
    }
  }, [player_id])

  function getPlayerLeagueList() {
    api_getPlayerLeagueList({
      player_id,
      success: (obj) => {
        console.log(obj)
        set_league_list(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function getPlayerHistoryList() {
    var mReqPlayerHistoryList = new ReqPlayerHistoryList({ player_id })
    api_getPlayerHistoryList({
      mReqPlayerHistoryList,
      success: (obj) => {
        console.log(obj)
        set_player_history_list(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function addPlayerHistoryInit() {
    var mRespPlayerHistory = new RespPlayerHistory({
      league_id,
      player_id,
      player_currently: PLAYER_CURRENTLY_NOW
    })

    console.log(mRespPlayerHistory)

    api_addPlayerHistory({
      mRespPlayerHistory,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '新增成功',
        }).then(function () {
          getPlayerHistoryList()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function onChange(league_id, items, player_debut) {
    // console.log(items)
    // set_player_historys(items)
    player_history_list.filter((item, index) => {
      if (item.league_id === league_id) {
        item.items = items
        if (player_debut !== null) {
          item.player_debut = player_debut
        }
      }
      console.log(player_history_list)
      return true
    })

    // console.log(player_history_list)
  }

  function player_debut_onChange(league_id, player_debut) {
    player_history_list.filter((item, index) => {
      if (item.league_id === league_id) {
        item.player_debut = player_debut
      }
      console.log(player_history_list)
      return true
    })
  }

  function toSave() {
    console.log(player_history_list)
    if (history_err) {

      Swal.fire({
        type: 'error',
        title: '提醒',
        text: "日期錯誤, 請檢查",
      })
    } else {

      api_updatePlayerHistorys({
        player_history_list,
        success: (jsonData) => {
          console.log(jsonData)
          setIsLoading(false)
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '更新成功',
          }).then(function () {
            // getPlayerHistoryList()
          })
        },
        failure: (err) => {
          setIsLoading(false)
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    }
  }

  function toCancel() {

  }

  var title = "球員歷程"
  var content =
    <>
      <div className="row">
        <Space />
        <Space />
        <div className="col-sm-12">
          <div className="row"><div className="col-md-4">
            <h3><p className="text-success">要加入新聯盟，請先輸入聯盟關鍵字</p> </h3>
          </div>
            <AutoSelect
              title={""}
              attr={league_list}
              val={league_id}
              v={'league_id'}
              n={'league_name'}
              action={set_league_id}
              size={3}
            />
            <AddButton name={"加入新聯盟"} action={addPlayerHistoryInit} disabled={league_id === ""} />
          </div>
        </div>
        <Space />
        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>
        <div className="col-sm-12">
          {
            player_history_list.map(player_history => (
              <PlayerHistory ph={player_history} action={onChange} pdAction={player_debut_onChange} errAction={set_history_err} />
            ))
          }
        </div>
      </div>

    </>


  var footer =
    <div className="row">
      <div className="col-sm-12">
        {
          <div className="col-sm-3 col-sm-offset-9">
            <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toSave} isRight={true} />
          </div>
        }
      </div>
    </div>
  return (
    <>
      <ContentBox title={title} content={content} hasDrawer={false} footer={footer} />


    </>
  )
}